import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class FunctionCallBlock extends AbstractBlock {
  FUNCTION_NAME = 'FUNCTION_NAME';

  constructor(name: string) {
    super(name, t.to('ブロック呼び出し', 'function_call'));
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setMoreColor(block);
    ShapeSettings.setElementShape(block);

    // フィールド
    const functionName = new Blockly.FieldTextInput(t.to('ブロック名', 'block_name'));
    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('ブロック', 'function_def_5') + ' [')
      .appendField(functionName, this.FUNCTION_NAME)
      .appendField(']' + t.to('に', 'function_def_6'));

    const arg = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(t.to('パラメータ', 'function_def_7') + '[')
      .appendField(arg, 'arg')
      .appendField(']' + t.to('を引き渡して呼び出し', 'function_def_8'));
  }

  codeGenerateCore(block: BlockType): string {
    const functionName = CodeSetting.getFieldValue(block, this.FUNCTION_NAME);
    const arg = CodeSetting.getFieldValue(block, 'arg');
    // let str = '{{' + functionName +  '(' + arg + ') }}' + "\n";
    // VDOM
    let argmentString = '';
    if (arg.indexOf('=') >= 0) {
      const argments = arg.split(',');
      for (const one_arg of argments) {
        const value = one_arg.split('=')[1];
        argmentString += argmentString === '' ? '' : ','; // 空っぽでなければカンマを入れる
        argmentString += value;
      }
    } else {
      argmentString = arg;
    }
    const str = ` ${functionName}( ${argmentString} );`;
    return str;
  }
}
